import lodash from 'lodash';

// Get all sum of all numbers of the array
const GetArraySum = (arr) =>  {
  return lodash.sum(arr);
}

export default GetArraySum;